import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from './index.less';
import { MicroApp } from 'umi';
import { getMicroAppName } from '@/constants';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';

interface FContractDetailsDrawer2Props {
  onClose?(): void;
}

function FContractDetailsDrawer2({ onClose }: FContractDetailsDrawer2Props) {
  return ReactDOM.createPortal(
    <MicroApp
      name={
        getMicroAppName('CollectionSignItems')
      }
      mainAppType={'contractDetail'}
      mainAppFuncs={{
        update() {
          // onUpdate?.({
          //   resourceId: licensorId,
          //   authExcludedItems: options.authExcludedItems ?? [],
          //   isAllAuthComplete: options.isAllAuthComplete ?? true,
          // });
        },
        onClose() {
          onClose?.();
        },
      }}
    />,
    self.document.body,
  );
}
// function FContractDetailsDrawer2({ onClose }: FContractDetailsDrawer2Props) {
//   return (
//     <MicroApp
//       name={
//         isTestEnv()
//           ? 'CollectionSignItems_test'
//           : 'CollectionSignItems'
//       }
//       mainAppType={'contractDetail'}
//       mainAppFuncs={{
//         update() {
//           // onUpdate?.({
//           //   resourceId: licensorId,
//           //   authExcludedItems: options.authExcludedItems ?? [],
//           //   isAllAuthComplete: options.isAllAuthComplete ?? true,
//           // });
//         },
//         onClose() {
//           onClose?.();
//         },
//       }}
//     />
//   );
// }

export default FContractDetailsDrawer2;

interface IState {
  contractId: string;
  contractDetailShow: boolean;
}

export function setState_FContractDetailsDrawer2(state: Partial<IState>) {
  MicroAppStateActionsMgr.setState(state);
}
